import ButtonLoader from "@components/loaders/ButtonLoader";
import React, { useEffect, useState } from "react";

type ButtonType = {
  text: string;
  onClick?: () => Promise<void> | void;
  isActive: boolean;
  ref?: React.Ref<HTMLButtonElement>;
  isButtonLoading?: boolean;
  buttonColor?: string;
  borderColor?: string;
  textColor?: string;
  className?: string;
  textSize?: string;
};

const LightCustomButton = React.forwardRef<HTMLButtonElement, ButtonType>(
  (props, ref) => {
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const handleVerification = async () => {
      if (!props.onClick || isButtonDisabled) return;
      setIsButtonDisabled(true);
      try {
        await props.onClick();
      } catch (error) {
        console.error("Error occurred:", error);
      } finally {
        setIsButtonDisabled(false);
      }
    };

    useEffect(() => {
      setIsButtonDisabled(!!props.isButtonLoading);
    }, [props.isButtonLoading]);

    const textSize = props.textSize || "12px";
    const customSurface = [props.buttonColor, props.borderColor, props.textColor]
      .filter(Boolean)
      .join(" ");
    const enabledSurface =
      customSurface ||
      "border-[#D7DEE8] bg-[#FFFFFF] text-[#15182C] hover:border-[#7EC8EA] hover:bg-[#F4FBFE] hover:text-[#2436C7]";

    return (
      <button
        ref={ref}
        type="button"
        style={{ fontSize: textSize }}
        className={`inline-flex h-8 shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg border px-3 font-semibold tracking-[-0.01em] shadow-[0_1px_2px_rgba(21,24,44,0.05)] transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#81d1f4]/70 focus-visible:ring-offset-1 active:translate-y-px active:shadow-none disabled:cursor-not-allowed ${
          props.isActive
            ? enabledSurface
            : "border-[#ECECEC] bg-[#F7F7F7] text-[#B7B7B7] shadow-none"
        } ${props.className || ""}`}
        onClick={props.isActive ? handleVerification : undefined}
        disabled={!props.isActive || isButtonDisabled}
      >
        {props.isButtonLoading ? <ButtonLoader /> : props.text}
      </button>
    );
  },
);

LightCustomButton.displayName = "LightCustomButton";

export default LightCustomButton;
